import {Box, Text} from 'exsportia-components'
import React, {FC} from 'react'

import {TranslatorScope} from '../../locale/types'
import {useLocale} from '../../utils/i18n'
import {useModalActions} from '../../utils/modals'

type ConfirmationModalProps = {
  description: TranslatorScope
}

export const ConfirmationModal: FC<ConfirmationModalProps> = ({description}) => {
  const {l} = useLocale()
  return (
    <Box>
      <Text text={l(description)} />
    </Box>
  )
}

type openConfirmationModalArgs = { onCancel?: () => void, onConfirm?: () => void, description: TranslatorScope}

export const useConfirmationModal = (): { openConfirmationModal: (data: openConfirmationModalArgs) => void} => {
  const {openModal, closeModal} = useModalActions()
  const {l} = useLocale()

  const openConfirmationModal = ({onConfirm, onCancel, description}: openConfirmationModalArgs) => {
    openModal({
      title: l('confirmation'),
      component: <ConfirmationModal description={description}/>,
      settings: {
        footer: {
          submitButton: {
            settings: {
              bg: 'primary',
            },
          },
        },
      },
      footerConfig: {
        submitButton: {
          onClick: () => {
            closeModal()
            if (onConfirm) {
              onConfirm()
            }
          },
          text: l('confirm'),
        },
        cancelButton: {
          onClick: () => {
            if (onCancel) {
              onCancel()
            } else {
              closeModal()
            }
          },
        },
      },
    })
  }

  return {openConfirmationModal}
}
